var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "text-right font-28" },
    [
      _vm.showLabel && _vm.showLabel.length > 0
        ? _c("span", [
            _vm._v(" " + _vm._s(_vm.showStringOrArray(_vm.showLabel)) + " "),
          ])
        : _vm.value && _vm.value.length > 0
        ? _c("span", [
            _vm._v(
              " " +
                _vm._s(
                  _vm.getShowLabel(
                    _vm.value,
                    _vm.treeData,
                    _vm.keyField,
                    _vm.labelField
                  )
                ) +
                " "
            ),
          ])
        : _c("span", { staticClass: "cor-CC" }, [
            _vm._v(" " + _vm._s(_vm.placeholder) + " "),
          ]),
      !_vm.value && !_vm.showLabel
        ? _c("van-icon", { attrs: { name: "arrow", color: "#8c8c8c" } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }